module.exports = __webpack_public_path__ + "images/08db1e6b5a625db94450d1da2ccece37-VO_ISW_IndoorCamera_LineArt_Green_200x200.png";